export type BackgroundColors =
	| 'white'
	| 'accent'
	| 'gradient-80px'
	| 'gradient-160px'
	| 'gradient-50';

export const BACKGROUND_CLASS_MAP: Record<BackgroundColors, string> = {
	white: 'bg-white',
	accent: 'bg-accent-25',
	'gradient-80px': 'bg-section-gradient-80',
	'gradient-160px': 'bg-section-gradient-160',
	'gradient-50': 'bg-section-gradient-50p',
};
